import { render, staticRenderFns } from "./CourseRate.vue?vue&type=template&id=65f85e5e&scoped=true&"
import script from "./CourseRate.vue?vue&type=script&lang=js&"
export * from "./CourseRate.vue?vue&type=script&lang=js&"
import style0 from "./CourseRate.vue?vue&type=style&index=0&id=65f85e5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f85e5e",
  null
  
)

export default component.exports